import React, { useEffect, useState } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { LocalCity } from './LocalCity';

export const LocalCityContainer = ({ ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const defaultVariables = {
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  }

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="local-city">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <LocalCity {...props} />
    </QueryProvider>
  );
};

LocalCityContainer.propTypes = {};

LocalCityContainer.defaultProps = {};
